import * as React from 'react';
import { storeDispatch } from 'state/Store';
import styled from 'styled-components';
import * as Actions from 'state/actions';
import { setValueInLocalStorage } from 'utils';

export const SKIP_FROM_DATA_ONBOARDING_STORAGE_KEY =
  'SKIP_FROM_DATA_ONBOARDING';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Popup = styled.div`
  background: white;
  color: black;
  border-radius: 12px;
  box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.25);
  padding: 32px;

  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;

  li {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 16px;

    .thumb {
      width: 40px;
      height: 40px;
      border-radius: 6px;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;

interface ListItemProps {
  icon: React.ReactNode;
  backgroundColor: string;
  children: React.ReactNode;
}
const ListItem: React.FC<ListItemProps> = props => {
  const { icon, backgroundColor, children } = props;
  return (
    <li>
      <div className="thumb" style={{ backgroundColor }}>
        {icon}
      </div>
      <span>{children}</span>
    </li>
  );
};

export const FromDataOnboarding: React.FC = () => {
  const dismiss = React.useCallback(dontShowAgain => {
    if (dontShowAgain === true) {
      setValueInLocalStorage(SKIP_FROM_DATA_ONBOARDING_STORAGE_KEY, 'true');
    }
    storeDispatch(Actions.closeModal());
  }, []);
  return (
    <Backdrop>
      <Popup>
        <div>
          <h1>Bring your design to life</h1>
          <div style={{ marginTop: 4 }}>
            Use the sidebar on the left to add graphics and animations.
          </div>
        </div>
        <List>
          <ListItem
            icon={
              <div
                style={{
                  width: 30,
                  height: 30,
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                  backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiPgogICAgICAgIDxwYXRoIGQ9Ik05LjUsNC41IEw5LjUsMTQuNSI+PC9wYXRoPgogICAgICAgIDxwYXRoIGQ9Ik00LjUsOS41IEwxNC41LDkuNSI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4=')`
                }}
              />
            }
            backgroundColor="var(--accent-color)"
          >
            Add stickers, audio waves and more...
          </ListItem>
          <ListItem
            icon={<img src="/media/icons/icon-effect.svg" />}
            backgroundColor="rgba(0,0,0,0.1)"
          >
            Add visual effects that can react to the soundtrack
          </ListItem>
          <ListItem
            icon={<img src="/media/icons/icon-soundtrack.svg" />}
            backgroundColor="var(--accent-color)"
          >
            Add a soundtrack (royalty free music available)
          </ListItem>
        </List>
        <Buttons>
          <button className="large tertiary" onClick={() => dismiss(true)}>
            Don't show this again
          </button>
          <button className="large primary" onClick={dismiss}>
            Ok
          </button>
        </Buttons>
      </Popup>
    </Backdrop>
  );
};



// WEBPACK FOOTER //
// ./src/modals/FromDataOnboarding.tsx